import React, { forwardRef } from 'react';
import classnames from 'classnames';
import { r_check } from '../../../icons';
import getRenderable from '../../../lib/getRenderable';
import Icon from '../Icon';
import {
    SHAPES,
    COLORS
} from './constants';
import classes from './index.module.scss';
import { CheckboxProps, ColorsType, ShapesType } from './types';

const getDefaultColor = (shape: ShapesType): ColorsType =>
    shape === 'square' ? 'white' : 'green';

/**
 * @deprecated Please use Checkbox from @fiverr-private/forms instead.
 */
const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(({
    children,
    className: customClassName,
    checkmarkClassName,
    disabled = false,
    isError = false,
    isSuccess = false,
    shape = 'square',
    color,
    ...rest
}, ref) => {
    color = color || getDefaultColor(shape);

    const className = classnames(
        classes.checkbox,
        classes[`color-${color}`],
        classes[`shape-${shape}`],
        {
            [classes.disabled]: disabled,
            [classes.error]: isError,
            [classes.success]: isSuccess
        },
        customClassName
    );

    const boxClasses = classnames(
        classes.checkmarkBox,
        {
            'box-shadow-z1': shape === 'circle'
        },
        checkmarkClassName
    );

    const inputProps = Object.assign({
        type: 'checkbox',
        disabled,
        ref
    }, rest);

    return (
        <label className={className}>
            <input {...inputProps}/>
            <span className={boxClasses}>
                <Icon className={classes.checkIcon}
                    size={10}>
                    {r_check}
                </Icon>
            </span>
            { getRenderable(children) }
        </label>
    );
});

Checkbox.displayName = 'Checkbox';

Object.assign(Checkbox, {
    SHAPES,
    COLORS
});

export default Checkbox;
